import { IImageSettings } from '@msdyn365-commerce/core';

export function findImagesSettingsInProps(props: any, onFound: (result: IImageSettings) => void) {
    if (!props) {
        return;
    }
    Object.keys(props).forEach(key => {
        if (key === '_owner' || key === 'type' || key === 'tag' || key === 'requestContext') {
            return;
        }

        if (key === 'imageSettings') {
            onFound(props[key]);
        } else if (key === 'props' || key === 'children' || key === 'items' || key === 'Picture' || key.match(/^\d+$/m) && typeof props[key] === 'object') {
            findImagesSettingsInProps(props[key], onFound);
        }
    });
}

export function fixImageSettings(imageSettings: IImageSettings) {
    if (imageSettings.mode) {
        // How to set this otherwise it will overwrite modes defined below
        imageSettings.mode = 0;
    }

    Object.keys(imageSettings.viewports || {}).forEach(key => {
        if (imageSettings.viewports[key].q) {
            imageSettings.viewports[key].q = imageSettings.viewports[key].q.replace(/f=(jpg|jpeg|png)/g, 'f=webp').replace(/m=\d/g, 'm=0');
        }
    });
}

export function findAndFixImageSettingsInProps(props: any) {
    findImagesSettingsInProps(props, (imageSettings: IImageSettings) => {
        fixImageSettings(imageSettings);
    });
}